module.exports = __webpack_public_path__ + "img/city.0b331ab3.png";